import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
// @mui
import { Box } from "@mui/material";

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default function Logo({ disabledLink = false, isFull = false, sx }) {
  const logo = (
    <Box
      component="img"
      src={isFull ? "/logo/logo_text.png" : "/logo/logo.png"}
      sx={{ width: "auto", height: isFull ? 50 : 40, ...sx }}
    />
  );

  if (disabledLink) {
    // eslint-disable-next-line
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
